module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 183);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("babel-helper-vue-jsx-merge-props");

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(14);
var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(3);
var external_lodash_default = /*#__PURE__*/__webpack_require__.n(external_lodash_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./packages/pro-table/src/table-props.js
var table_props = __webpack_require__(48);

// EXTERNAL MODULE: ./packages/pro-table/src/table-mixin.js
var table_mixin = __webpack_require__(58);

// CONCATENATED MODULE: ./packages/pro-table/src/pro-table.js


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var pro_table = (external_vue_default.a.extend({
  name: 'ElProTable',
  mixins: [table_mixin["a" /* default */]],
  props: _extends({}, table_props["a" /* COMMON_TABLE_PROPS */]),
  data: function data() {
    return {};
  },

  computed: {
    innerTableColumns: function innerTableColumns() {
      var vxeColumns = this.vxeColumns;

      var ret = [];
      return ret.concat(vxeColumns);
    },
    innerDataList: function innerDataList() {
      var autoPagination = this.autoPagination,
          showPagination = this.showPagination,
          data = this.data,
          innerCurrentPage = this.innerCurrentPage,
          innerPageSize = this.innerPageSize,
          innerSortList = this.innerSortList,
          isSortAllData = this.isSortAllData,
          sortData = this.sortData,
          tableListTransform = this.tableListTransform,
          total = this.total;

      var ret = data;
      if (typeof tableListTransform === 'function') {
        ret = tableListTransform(data);
      }
      // 前端排序逻辑
      if (isSortAllData && !external_lodash_default.a.isEmpty(innerSortList)) {
        ret = sortData(ret, innerSortList);
      }
      if (showPagination && autoPagination && !external_lodash_default.a.isEmpty(ret)) {
        // 设置数据总数量
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.innerTotal = ret.length;
        if (ret && ret.length && ret.length > 0) {
          var fromIndex = (innerCurrentPage - 1) * innerPageSize;
          if (fromIndex < 0) {
            fromIndex = 0;
          }
          var toIndex = innerCurrentPage * innerPageSize;
          if (toIndex > total) {
            toIndex = total + 1;
          }
          return ret.slice(fromIndex, toIndex);
        }
      }
      return ret;
    }
  },
  methods: {
    /**
     * 用于 type=checkbox，设置行为选中状态，第二个参数为选中与否
     * @public
     * @param {object | array} rows 欲更改选中状态的行数据对象
     * @param {*} checked 是否选中
     */
    setCheckboxRow: function setCheckboxRow(rows, checked) {
      this.getTableRef().setCheckboxRow(rows, checked);
    },
    recalculate: function recalculate(refull) {
      this.getTableRef().recalculate(refull);
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var $slots = this.$slots,
        $attrs = this.$attrs,
        innerCurrentPage = this.innerCurrentPage,
        isTree = this.isTree,
        innerDataList = this.innerDataList,
        innerPageSize = this.innerPageSize,
        vxeTableColumnArray = this.vxeTableColumnArray,
        innerSeqConfig = this.innerSeqConfig,
        innerTotal = this.innerTotal,
        layouts = this.layouts,
        rowKey = this.rowKey,
        height = this.height,
        maxHeight = this.maxHeight,
        innerMergeCells = this.innerMergeCells,
        innerCheckboxConfig = this.innerCheckboxConfig,
        innerTreeConfig = this.innerTreeConfig,
        innerRadioConfig = this.innerRadioConfig,
        innerExpandConfig = this.innerExpandConfig,
        innerSortConfig = this.innerSortConfig,
        innerExportConfig = this.innerExportConfig,
        innerPageSizes = this.innerPageSizes,
        onPageChange = this.onPageChange,
        onTableCheckboxAll = this.onTableCheckboxAll,
        onTableCheckboxChange = this.onTableCheckboxChange,
        onTableRadioChange = this.onTableRadioChange,
        onCellClick = this.onCellClick,
        mergeFooterItems = this.mergeFooterItems,
        footerMethod = this.footerMethod,
        showFooter = this.showFooter,
        onCellMenu = this.onCellMenu,
        onMenuClick = this.onMenuClick,
        onSortChange = this.onSortChange,
        showPagination = this.showPagination,
        getColumnSettingRender = this.getColumnSettingRender,
        rowClassName = this.rowClassName;

    this.$nextTick(function () {
      // 表格状态发生变化时，临时合并失效，需要重新合并
      _this.refreshTempState();
    });
    return h(
      'div',
      { 'class': 'el-table-container' },
      [h(
        'div',
        { 'class': 'el-pro-table__toolbar' },
        [h('div', [$slots.batchControl]), h(
          'div',
          { 'class': 'toolbar__table-common' },
          [getColumnSettingRender()]
        )]
      ), h(
        'div',
        { 'class': 'el-pro-table__main' },
        [h('vxe-grid', external_babel_helper_vue_jsx_merge_props_default()([{
          ref: 'xTable',
          'class': 'el-pro-table'
        }, { attrs: $attrs }, {
          attrs: {
            size: 'mini',
            'scroll-x': { gt: 15 },
            'scroll-y': { gt: 20 },
            border: true,
            resizable: true,
            'auto-resize': true,
            'highlight-hover-row': true,
            'highlight-current-row': true,
            data: innerDataList,
            columns: vxeTableColumnArray,
            'seq-config': innerSeqConfig,
            height: height,
            'max-height': maxHeight,
            'row-id': rowKey,
            'merge-cells': innerMergeCells,
            'edit-config': {},
            'checkbox-config': innerCheckboxConfig,
            'radio-config': innerRadioConfig,
            'expand-config': innerExpandConfig,
            'tree-config': innerTreeConfig,
            'sort-config': innerSortConfig,
            'export-config': innerExportConfig,

            'show-footer': showFooter,
            'footer-method': footerMethod,
            'merge-footer-items': mergeFooterItems,
            'row-class-name': rowClassName
          },
          on: {
            'checkbox-change': onTableCheckboxChange,
            'checkbox-all': onTableCheckboxAll,
            'radio-change': onTableRadioChange,
            'cell-click': onCellClick,
            'cell-menu': onCellMenu,
            'menu-click': onMenuClick,
            'sort-change': onSortChange
          }
        }]))]
      ), showPagination && !isTree ? h('vxe-pager', {
        attrs: {
          background: true,
          size: 'small',
          'current-page': innerCurrentPage,
          layouts: layouts,
          'page-size': innerPageSize,
          total: innerTotal,
          'page-sizes': innerPageSizes
        },
        on: {
          'page-change': onPageChange
        }
      }) : null]
    );
  }
}));
// CONCATENATED MODULE: ./packages/pro-table/index.js


/* istanbul ignore next */
pro_table.install = function install(Vue) {
  Vue.component(pro_table.name, pro_table);
};

/* harmony default export */ var packages_pro_table = __webpack_exports__["default"] = (pro_table);

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/schema");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("xe-utils");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(3);
var external_lodash_default = /*#__PURE__*/__webpack_require__.n(external_lodash_);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(6);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/schema"
var schema_ = __webpack_require__(20);

// CONCATENATED MODULE: ./packages/pro-table/src/vxe-column.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VxeColumn = function VxeColumn() {
  _classCallCheck(this, VxeColumn);

  /**
   * 列ID
   */
  this.colId = null;
  /**
   * 渲染类型
   */
  this.type = null;
  /**
   * 列字段名
   */
  this.field = null;
  /**
   * 列标题
   */
  this.title = null;
  /**
   * 列宽度
   */
  this.width = null;
  /**
   * 列最小宽度，把剩余宽度按比例分配
   */
  this.minWidth = null;
  /**
   * 是否允许拖动列宽调整大小
   */
  this.resizable = null;
  /**
   * 将列固定在左侧或者右侧
   */
  this.fixed = null;
  /**
   * 列对其方式
   */
  this.align = null;
  /**
   * 表头对齐方式
   */
  this.headerAlign = null;
  /**
   * 表尾列的对齐方式
   */
  this.footerAlign = null;
  /**
   * 当内容过长时显示为省略号
   */
  this.showOverflow = null;
  /**
   * 当表头内容过长时显示为省略号
   */
  this.showHeaderOverflow = null;
  /**
   * 当表尾内容过长时显示为省略号
   */
  this.showFooterOverflow = null;
  /**
   * 给单元格附加 className
   */
  this.className = null;
  /**
   * 给表头单元格附加 className
   */
  this.headerClassName = null;
  /**
   * 给表尾单元格附加 className
   */
  this.footerClassName = null;
  /**
   * 格式化显示内容
   */
  this.formatter = null;
  /**
   * 是否允许排序
   */
  this.sortable = null;
  /**
   * 自定义排序的属性
   */
  this.sortBy = null;
  /**
   * 排序的字段类型，比如字符串转数值等
   */
  this.sortType = null;
  /**
   * 配置筛选条件数组
   */
  this.filters = null;
  /**
   * 筛选是否允许多选
   */
  this.filterMultiple = null;
  /**
   * 自定义筛选方法
   */
  this.filterMethod = null;
  /**
   * 筛选模板配置项
   */
  this.filterRender = null;
  /**
   * 指定为树节点
   */
  this.treeNode = null;
  /**
   * 是否可视
   */
  this.visible = true;
  /**
   * 自定义单元格数据导出方法
   */
  this.exportMethod = null;
  /**
   * 自定义表尾单元格数据导出方法
   */
  this.footerExportMethod = null;
  /**
   * 标题帮助图标配置项
   */
  this.titleHelp = null;
  /**
   * 单元格值类型
   */
  this.cellType = null;
  /**
   * 单元格渲染配置项
   */
  this.cellRender = null;
  /**
   * 单元格编辑渲染配置项
   */
  this.editRender = null;
  /**
   * 内容渲染配置项
   */
  this.contentRender = null;
  /**
   * 额外的参数
   */
  this.params = null;
  /**
   * 是否含有自定义插槽
   */
  this.hasCustomSlot = false;
  /**
   * 内部使用
   * 父节点Field
   */
  this.srParentField = null;
};

/* harmony default export */ var vxe_column = (VxeColumn);
// CONCATENATED MODULE: ./packages/pro-table/src/util.js
/* unused harmony export getSchemaByKeyArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertSchemaToColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEditRenderByProperty; });
/* unused harmony export calculateSchema */
/* unused harmony export getSchemaDefaultObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSchemaDefaultObjectByFormSchema; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






// SLOT_EXPAND
var SLOT_NAME_EXPAND_CONTENT = 'content';
var SLOT_NAME_HEADER_PREFIX = 'header.';

/**
 * 根据字符串数组取得对应的schema对象
 * @param {Object} schema
 * @param {Array} arr
 * @returns
 */
function getSchemaByKeyArray(schema, arr) {
  var ret = {};
  if (schema && schema.properties && arr.length > 0) {
    arr.forEach(function (key) {
      if (typeof key === 'string') {
        var prop = schema.properties[key];
        if (prop === undefined) {
          console.log('当前使用的Schema为', schema);
          console.error('Schema\u5185\u4E0D\u5B58\u5728\u8BBE\u5B9A\u7684 ' + key + ' \u7684\u9879\u76EE\u3002');
        }
        if (prop) {
          ret[key] = prop;
        }
      } else {
        ret[key.key] = key;
      }
    });
  }
  return {
    properties: _extends({}, ret)
  };
}

function byteLength(str) {
  var length = 0;
  Array.from(str).forEach(function (char) {
    if (char.charCodeAt(0) > 255) {
      // 字符编码大于255，说明是双字节字符
      length += 2;
    } else {
      length += 1;
    }
  });

  return length;
}

function convertSchemaToColumns(schema) {
  var uiSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var scopedSlots = arguments[2];
  var columnWidth = arguments[3];
  var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var ret = [];
  var properties = schema.properties;

  if (!properties) {
    return ret;
  }
  var currentUiSchema = uiSchema || {};
  Object.keys(properties).forEach(function (key) {
    var property = properties[key];
    var uiProperty = currentUiSchema[key] || {};
    var column = new vxe_column();
    // 列字段名
    column.field = key;
    if (!external_lodash_default.a.isEmpty(uiProperty[constants["c" /* JSON_FORM_UI */].UI_PARENT_COLUMN_ID])) {
      column.srParentField = uiProperty[constants["c" /* JSON_FORM_UI */].UI_PARENT_COLUMN_ID];
    }
    // 列提示
    if (!external_lodash_default.a.isEmpty(property.description)) {
      column.titleHelp = {
        message: property.description
      };
    }
    // INDEX序号列的场合
    if (property.type === constants["a" /* COLUMN_TYPE */].INDEX) {
      column.type = 'seq';
    }
    column.headerAlign = 'left';
    // 列标题
    column.title = property.title;
    if (property.type === 'number' || property.type === 'integer') {
      column.headerAlign = 'right';
      column.align = 'right';
    }
    // 列宽度
    var width = uiProperty.width;

    if (!external_lodash_default.a.isEmpty(width) && width.indexOf('px')) {
      width = width.replace('px', '');
      // 根据字符数量计算列的宽度 FIXME 列和标题字数较少时的处理
    } else if (columnWidth === 'auto') {
      var defaultMinWidth = byteLength(column.title) * 20;
      if (defaultMinWidth < 100) {
        defaultMinWidth = 100;
      }
      column.minWidth = defaultMinWidth + 'px';
    } else if (!external_lodash_default.a.isEmpty(columnWidth)) {
      width = columnWidth;
    }
    if (width) {
      column.width = '' + width;
    }
    // 序号列不进行排序
    if (column.field !== 'index') {
      // 排序
      var sortable = property.sortable;

      var uiSchemaOptionsSortable = external_lodash_default.a.get(uiProperty, [constants["c" /* JSON_FORM_UI */].UI_OPTIONS, 'sortable']);
      // ui-schema内的属性最优先
      if (typeof uiSchemaOptionsSortable === 'boolean') {
        sortable = uiSchemaOptionsSortable;
        // 默认排序设置次优先
      } else if (config.defaultAllColumnSort) {
        sortable = true;
      }
      // metadata内的sortable优先级最低
      column.sortable = sortable;
    }
    // 格式化显示内容
    var formatter = uiProperty.formatter;

    if (property.type !== constants["a" /* COLUMN_TYPE */].INDEX) {
      if (typeof formatter === 'function') {
        // eslint-disable-next-line no-shadow
        column.formatter = function (_ref) {
          var row = _ref.row,
              col = _ref.col,
              cellValue = _ref.cellValue;
          return formatter(row, col, cellValue);
        };
      } else if (formatter && typeof formatter === 'string') {
        if (formatter === 'date') {
          column.formatter = schema_["dateFormatter"];
        } else if (formatter === 'datetime') {
          column.formatter = schema_["dateTimeFormatter"];
        } else if (formatter === 'boolean') {
          column.formatter = schema_["booleanFormatter"];
        }
      } else {
        // 设置默认formatter
        var _formatter = Object(schema_["createFormatter"])(property);
        if (_formatter) {
          column.formatter = function (_ref2) {
            var cellValue = _ref2.cellValue;

            return _formatter(cellValue);
          };
        }
      }
    }
    if (uiProperty.fixed) {
      column.fixed = uiProperty.fixed;
    }
    // 列插槽处理
    column.slots = {};
    if (scopedSlots[key]) {
      column.hasCustomSlot = true;
      var defaultSlot = function defaultSlot(scope) {
        var s = scope;
        s.rowStatus = 'default';
        var render = scopedSlots[key](s);
        return render;
      };
      var editSlot = function editSlot(scope) {
        var s = scope;
        s.rowStatus = 'edit';
        var render = scopedSlots[key](s);
        return render;
      };
      // 单元格内容渲染配置项
      column.slots = {
        default: defaultSlot,
        srScopedDefault: defaultSlot,
        // 默认设置编辑状态插槽
        // 默认插槽内容可通过formatter进行设置
        edit: editSlot,
        srScopedEdit: editSlot
      };
    }
    var headerSlotKey = '' + SLOT_NAME_HEADER_PREFIX + key;
    // 表格头部自定义插槽
    if (scopedSlots[headerSlotKey]) {
      var headerSlot = function headerSlot(scope) {
        var s = scope;
        var render = scopedSlots[headerSlotKey](s);
        return render;
      };
      column.slots.header = headerSlot;
    }
    // 展开行
    if (scopedSlots[SLOT_NAME_EXPAND_CONTENT] && config && config.expand && config.expand.labelField && config.expand.labelField === key) {
      column.slots.content = scopedSlots[SLOT_NAME_EXPAND_CONTENT];
    }
    if (!external_lodash_default.a.isEmpty(uiProperty[constants["c" /* JSON_FORM_UI */].UI_OPTIONS])) {
      Object.keys(uiProperty[constants["c" /* JSON_FORM_UI */].UI_OPTIONS]).forEach(function (optionKey) {
        if (external_lodash_default.a.has(column, optionKey)) {
          column[optionKey] = uiProperty[constants["c" /* JSON_FORM_UI */].UI_OPTIONS][optionKey];
        }
      });
    }
    if (!uiProperty[constants["c" /* JSON_FORM_UI */].UI_HIDDEN]) {
      ret.push(column);
    }
  });
  return ret;
}

/**
 * 根据Property取得EditRender内容
 * @param {*} property
 * @param {*} uiProperty
 */
function getEditRenderByProperty(key) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var uiProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var props = {
    events: {}
  };
  if (typeof uiProperty[constants["c" /* JSON_FORM_UI */].UI_DISABLED] === 'function') {
    props.disabledFunction = uiProperty[constants["c" /* JSON_FORM_UI */].UI_DISABLED];
  } else if (typeof uiProperty[constants["c" /* JSON_FORM_UI */].UI_DISABLED] === 'boolean') {
    props.disabled = uiProperty[constants["c" /* JSON_FORM_UI */].UI_DISABLED];
  }
  var component = Object(schema_["createElementByProperty"])(key, property, uiProperty, {}, function () {});
  props = Object.assign({}, props, component.componentProps.props);
  if (uiProperty[constants["c" /* JSON_FORM_UI */].UI_ON]) {
    var uiOn = uiProperty[constants["c" /* JSON_FORM_UI */].UI_ON];
    // 合并事件定义
    Object.keys(uiOn).forEach(function (uiOnKey) {
      // 自定义事件已被注册的场合，把注册的事件和自定义的事件按顺序执行
      if (typeof props.events[uiOnKey] === 'function') {
        props.events[uiOnKey] = function () {
          props.events[uiOnKey]();
          uiOn[uiOnKey]();
        };
      } else {
        props.events[uiOnKey] = uiOn[uiOnKey];
      }
    });
  }
  if (uiProperty[constants["c" /* JSON_FORM_UI */].UI_NATIVE_ON]) {
    var uiNativeOn = uiProperty[constants["c" /* JSON_FORM_UI */].UI_NATIVE_ON];
    // 合并事件定义
    Object.keys(uiNativeOn).forEach(function (uiOnKey) {
      // 自定义事件已被注册的场合，把注册的事件和自定义的事件按顺序执行
      if (typeof props.events[uiOnKey] === 'function') {
        props.nativeEvents[uiOnKey] = function () {
          props.nativeEvents[uiOnKey]();
          uiNativeOn[uiOnKey]();
        };
      } else {
        props.nativeEvents[uiOnKey] = uiNativeOn[uiOnKey];
      }
    });
  }
  return {
    name: component.componentTagName,
    attrs: component.componentProps.attrs,
    props: props,
    options: component.componentChildrenOptions
  };
}

/**
 * 根据 schemaArray 数组及 excludeSchemaArray 计算真实的schema
 * @param schema 完整的schema
 * @param schemaArray 需展示的字段列表（字符串或对象列表） (对应的formSchema、tableSchema属性)
 * @param excludeSchemaArray 不需展示的字段列表（字符串列表）
 *
 * @return {*} 最终的 JSON Schema
 */
function calculateSchema(schema, schemaArray, excludeSchemaArray) {
  if (!schema || !schema.properties) {
    return { properties: {} };
  }
  // if (schemaArray && _.isArray(schemaArray) && schemaArray.length > 0) {
  if (schemaArray && external_lodash_default.a.isArray(schemaArray)) {
    return _extends({}, schema, {
      properties: getSchemaByKeyArray(schema, schemaArray).properties
    });
  }

  var remainKeys = Object.keys(schema.properties);
  if (excludeSchemaArray && external_lodash_default.a.isArray(excludeSchemaArray) && excludeSchemaArray.length > 0) {
    external_lodash_default.a.remove(remainKeys, function (key) {
      return excludeSchemaArray.indexOf(key) >= 0;
    });
  }
  return _extends({}, schema, {
    properties: getSchemaByKeyArray(schema, remainKeys).properties
  });
}

function getItemDefaultValue() {
  var schemaItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var val = schemaItem.nullable;
  if (val === undefined || val === true) {
    return null;
  }
  return '';
}

/**
 * 根据schema定义生成指定初始化对象
 * @param {Object} schema
 * @returns
 */
function getSchemaDefaultObject() {
  var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ret = {};
  Object.keys(schema.properties).forEach(function (key) {
    ret[key] = getItemDefaultValue(schema.properties[key]);
  });
  return ret;
}

/**
 * 根据formSchema生成初始化对象
 * @param formSchema 对象或数组
 * @param schema 完整schema对象
 * @returns {{}}
 */
function getSchemaDefaultObjectByFormSchema(formSchema, schema) {
  var ret = {};
  if (formSchema) {
    if (external_lodash_default.a.isPlainObject(formSchema)) {
      ret = getSchemaDefaultObject(formSchema);
    } else if (external_lodash_default.a.isArray(formSchema)) {
      if (schema) {
        formSchema.forEach(function (key) {
          ret[key] = getItemDefaultValue(schema.properties[key]);
        });
      } else {
        formSchema.forEach(function (key) {
          ret[key] = '';
        });
      }
    }
  }
  return ret;
}

// /**
//  * 解析excel文件
//  * @return 数据数组
//  */
// export function parseExcelByFile(file, sheetNameArray, ignoreHeaderRow = true) {
//   return new window.Promise((resolve, reject) => {
//     const fileReader = new FileReader();
//     fileReader.onload = (ev) => {
//       const ret = [];
//       try {
//         const data = ev.target.result;
//         const workbook = xlsx.read(data, { type: 'binary' });
//         console.log(workbook);
//         const { Sheets } = workbook;
//         sheetNameArray.forEach((sheetName) => {
//           const targetSheet = Sheets[sheetName];
//           const FS = '^%_&_&';
//           const RS = '__(_&)';
//           const csvData = xlsx.utils.sheet_to_csv(targetSheet, {
//             FS,
//             RS,
//           });
//           const tableData = [];
//           // 解析数据
//           csvData.split(RS).forEach((vRow, index) => {
//             if (!(ignoreHeaderRow && index === 0)) {
//               if (vRow) {
//                 tableData.push(vRow.split(FS));
//               }
//             }
//           });
//           ret.push(tableData);
//         });
//         console.log(ret);
//         resolve(ret);
//       } catch (err) {
//         reject(err);
//       }
//     };
//     fileReader.readAsBinaryString(file);
//   });
// }

/* harmony default export */ var util = ({
  convertSchemaToColumns: convertSchemaToColumns,
  getEditRenderByProperty: getEditRenderByProperty,
  calculateSchema: calculateSchema
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMON_TABLE_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TABLE_PROPS; });
/**
 * 列表组件通用的props
 */
var COMMON_TABLE_PROPS = {
  // 数据
  data: null,
  schema: {
    type: Object,
    required: true
  },
  uiSchema: Object,
  // 行主键
  rowKey: String,
  height: {
    type: String,
    default: null
  },
  maxHeight: {
    type: String
    // default: '425px',
  },
  /**
   * 首页列表选择类型
   */
  selectionType: {
    type: String,
    required: false,
    default: null,
    validator: function validator(value) {
      return ['radio', 'checkbox', ''].indexOf(value) >= 0;
    }
  },
  multipleSelection: {
    type: Boolean,
    default: false
  },
  /**
   * Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
   */
  selectable: Function,
  // 获取行数据操作按钮
  getRowButton: Function,
  /**
   * 校验规则
   */
  rules: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  /**
   * 列表数据转换函数
   */
  tableListTransform: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * 标识上级节点的字段名
   */
  parentField: {
    type: String,
    required: false,
    default: null
  },
  // 列宽度
  columnWidth: String,
  // 前端分页
  autoPagination: {
    type: Boolean,
    required: false,
    default: true
  },
  // 是否所有列默认允许排序
  defaultAllColumnSort: {
    type: Boolean,
    default: false
  },
  // 是否保留CheckBox选中状态
  isReserve: {
    type: Boolean,
    required: false,
    default: false
  },
  mergeCells: Function,
  // 加载状态
  loading: Boolean,
  // 获取行数据快捷菜单按钮  menu-button-click
  menuConfig: Object,
  checkStrictly: {
    type: Boolean,
    required: false,
    default: false
  },
  mergeFooterItems: Array,
  footerMethod: Function,
  showFooter: Boolean,
  // 序号配置项
  seqConfig: Object,
  // 复选框配置项
  checkboxConfig: Object,
  // 单选框配置项
  radioConfig: Object,
  // 展开行配置项（不能用于虚拟滚动）
  expandConfig: Object,
  // 树形结构配置项
  treeConfig: {
    type: Object,
    default: function _default() {
      return {
        children: 'children'
      };
    }
  },
  // 排序配置项
  sortConfig: Object,
  // 导出配置项
  exportConfig: Object,
  // 数据代理配置项
  proxyConfig: Object,
  // 指定为树节点
  treeNode: String,
  // 是否使用虚拟树
  virtualTree: Boolean,
  // 全表排序自定义函数
  sortMethod: Function,
  // 是否显示分页
  showPagination: {
    type: Boolean,
    default: true
  },
  // 当前页号
  pageNum: Number,
  // 每页显示数据数量
  pageSize: Number,
  // 数据总数量
  total: Number,
  // 控制列宽度
  controlColumnWidth: {
    type: String,
    default: '120'
  },
  // 表格ID，主要用于对表格的配置进行缓存
  tableId: String,
  // 是否显示"全部展开"按钮，：is-tree="true"时生效，默认为true
  showExpandAllBtn: {
    type: Boolean,
    required: false,
    default: true
  },
  // 是否显示"全部收缩"按钮，：is-tree="true"时生效，默认为true
  showCollapseAllBtn: {
    type: Boolean,
    required: false,
    default: true
  },
  showColumnSetting: {
    type: Boolean,
    default: true
  },
  rowClassName: null
};

var EDIT_TABLE_PROPS = {
  /**
   * "新增同级"按钮点击事件
   */
  onAddCurrentClick: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * "新增子级"按钮点击事件
   */
  onAddChildClick: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * "新增一行"按钮点击事件
   */
  onAddRowClick: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * "批量删除"按钮点击事件
   */
  onDeleteClick: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * 新增一行按钮点击时的回调函数，用于对新增数据进行默认值设定
   */
  beforeAddRow: Function,
  /**
   * "新增同级"按钮点击前回调函数
   */
  beforeAddCurrent: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * "新增子级"按钮点击前回调函数
   */
  beforeAddChild: {
    type: Function,
    required: false,
    default: null
  },
  /**
   * 是否强制在行内编辑
   */
  isForceEditInRow: {
    type: Boolean,
    required: false,
    default: null
  },
  /**
   * ChangeMode 字段名
   */
  changeModeField: {
    type: String,
    required: false,
    default: 'ChangeMode'
  },
  /**
   * 与子节点关联的字段名，默认使用 rowKey的值
   */
  refField: {
    type: String,
    required: false,
    default: null
  },
  // 导入的Sheet名称
  importSheetName: String,
  // 导入后自定义数据处理
  afterImport: Function,
  // 可编辑配置项
  editConfig: Object,
  // 点击对话框的表单保存按钮后执行，可返回Promise或Boolean
  save: Function
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  COMMON_TABLE_PROPS: COMMON_TABLE_PROPS,
  EDIT_TABLE_PROPS: EDIT_TABLE_PROPS
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var xe_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var xe_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(xe_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45);





var COLUMN_CONTROL_TITLE = '操作';
var MODIFY_BUTTON = {
  key: 'ept-modify',
  label: '修改'
};
var DEFAULT_PAGE_SIZE = 10;
var DEFAULT_PAGE_SIZES = [1, 10, 20, 50, 100];
var MAX_EXPORT_DATA_LENGTH = 10000;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    labelMode: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      // 当前选中的行
      innerSelection: [],
      // 当前排序状态
      sortList: [],
      /* 分页有关属性 BEGIN */
      innerCurrentPage: 1,
      innerPageSize: DEFAULT_PAGE_SIZE,
      innerTotal: 0,
      layouts: ['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump'],
      innerPageSizes: DEFAULT_PAGE_SIZES,
      /* 分页有关属性 END */
      cloneVxeTableColumnArray: [],
      columnSettingKeys: [],
      columnSettingCheckedKeys: [],
      columnSettingDefaultCheckedKeys: [],
      isParticalColumnShow: false,
      isAllColumnShow: true
    };
  },

  watch: {
    pageNum: {
      immediate: true,
      handler: function handler(val) {
        this.innerCurrentPage = val || 1;
      }
    },
    pageSize: {
      immediate: true,
      handler: function handler(val) {
        this.innerPageSize = val || DEFAULT_PAGE_SIZE;
      }
    },
    pageSizes: {
      immediate: true,
      handler: function handler(val) {
        this.innerPageSizes = val || DEFAULT_PAGE_SIZES;
      }
    },
    total: {
      immediate: true,
      handler: function handler(val) {
        this.innerTotal = val;
      }
    },
    innerCurrentPage: function innerCurrentPage(val) {
      this.$emit('current-change', val);
      this.$emit('update:page-num', val);
    },
    innerPageSize: function innerPageSize(val) {
      this.$emit('size-change', val);
      this.$emit('update:page-size', val);
    }
  },
  computed: {
    innerUiSchema: function innerUiSchema() {
      return this.uiSchema || {};
    },
    innerSeqConfig: function innerSeqConfig() {
      var innerCurrentPage = this.innerCurrentPage,
          innerPageSize = this.innerPageSize,
          innerTableColumns = this.innerTableColumns,
          seqConfig = this.seqConfig,
          showPagination = this.showPagination,
          uiSchema = this.uiSchema;

      var startIndex = showPagination ? (innerCurrentPage - 1) * innerPageSize : 0;
      var defaultConfig = {
        startIndex: startIndex
      };
      var index = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.findIndex(innerTableColumns, function (item) {
        return item.type === 'seq';
      });
      if (index !== -1) {
        var seqColumn = innerTableColumns[index];

        var _ref = uiSchema[seqColumn.field] || {},
            formatter = _ref.formatter;

        if (typeof formatter === 'function') {
          defaultConfig.seqMethod = formatter;
        }
        return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, seqConfig);
      }
      return {};
    },
    isTree: function isTree() {
      return !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(this.treeNode);
    },
    isSortAllData: function isSortAllData() {
      // 前端分页并且渲染非树形数据的场合
      if (this.autoPagination && !this.isTree) {
        // 列开启了排序功能的场合
        if (this.defaultAllColumnSort) {
          return true;
        }
      }
      return false;
    },
    innerCheckboxConfig: function innerCheckboxConfig() {
      var ret = {};
      var labelMode = this.labelMode,
          isReserve = this.isReserve,
          selectable = this.selectable,
          isMultipleSelect = this.isMultipleSelect,
          checkStrictly = this.checkStrictly,
          _checkboxConfig = this.checkboxConfig,
          checkboxConfig = _checkboxConfig === undefined ? {} : _checkboxConfig;

      var defaultCheckboxConfig = {
        reserve: isReserve,
        checkStrictly: checkStrictly
      };
      if (labelMode !== false) {
        defaultCheckboxConfig.trigger = 'row';
      }
      if (isMultipleSelect || !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(checkboxConfig)) {
        if (typeof selectable === 'function') {
          defaultCheckboxConfig.checkMethod = selectable;
        }
        ret = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultCheckboxConfig, checkboxConfig);
      }
      return ret;
    },
    innerRadioConfig: function innerRadioConfig() {
      var isReserve = this.isReserve,
          labelMode = this.labelMode,
          _radioConfig = this.radioConfig,
          radioConfig = _radioConfig === undefined ? {} : _radioConfig,
          selectable = this.selectable,
          selectionType = this.selectionType;
      // TODO 单选项保留状态没有起作用

      var defaultRadioConfig = {
        reserve: isReserve
      };
      if (labelMode !== false) {
        defaultRadioConfig.trigger = 'row';
      }
      if (selectionType === 'radio') {
        if (typeof selectable === 'function') {
          defaultRadioConfig.checkMethod = selectable;
        }
        return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultRadioConfig, radioConfig);
      }
      return {};
    },
    innerExpandConfig: function innerExpandConfig() {
      var _expandConfig = this.expandConfig,
          expandConfig = _expandConfig === undefined ? {} : _expandConfig;

      var defaultConfig = {};
      return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, expandConfig);
    },
    innerTreeConfig: function innerTreeConfig() {
      var expandRowKeys = this.expandRowKeys,
          isTree = this.isTree,
          treeConfig = this.treeConfig;

      if (!isTree) {
        return null;
      }
      var defaultConfig = {};
      if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(expandRowKeys)) {
        defaultConfig.expandRowKeys = expandRowKeys;
      }
      var ret = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, treeConfig);
      return ret;
    },
    innerSortConfig: function innerSortConfig() {
      var isSortAllData = this.isSortAllData,
          isTree = this.isTree,
          sortConfig = this.sortConfig;
      // 树形结构不支持排序

      if (isTree) {
        return null;
      }
      var defaultConfig = {
        trigger: 'cell',
        orders: ['asc', 'desc'],
        // 前端对全部数据进行排序的场合，需要关闭当前页的默认排序逻辑
        remote: isSortAllData
      };
      var ret = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, sortConfig);
      return ret;
    },
    innerCustomConfig: function innerCustomConfig() {
      var customConfig = this.customConfig,
          tableId = this.tableId;

      var isStorageConfig = !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(tableId);
      var defaultConfig = {
        storage: {
          visible: isStorageConfig,
          resizable: isStorageConfig
        },
        checkMethod: function checkMethod(val) {
          return true;
        }
      };
      return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, customConfig);
    },
    innerExportConfig: function innerExportConfig() {
      var exportConfig = this.exportConfig,
          getTableActionRef = this.getTableActionRef,
          innerTableColumns = this.innerTableColumns;

      var defaultConfig = {
        types: ['csv'],
        modes: ['all'],
        beforeExportMethod: function beforeExportMethod(opt) {
          var options = opt.options;

          options.data = getTableActionRef().getFullData();
          options.columns = innerTableColumns;
          return opt;
        }
      };
      return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, exportConfig);
    },
    innerProxyConfig: function innerProxyConfig() {
      var proxyConfig = this.proxyConfig;

      var defaultConfig = {
        ajax: {
          queryAll: function queryAll() {
            return [];
          }
        }
      };
      return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, proxyConfig);
    },
    innerDefaultAllColumnSort: function innerDefaultAllColumnSort() {
      var autoPagination = this.autoPagination,
          defaultAllColumnSort = this.defaultAllColumnSort,
          isTree = this.isTree;
      // 后端分页的场合，不开启所有列的默认排序

      if (!autoPagination) {
        return false;
      }
      // 树形数据的场合，不开启所有列的默认排序
      if (isTree) {
        return false;
      }
      return defaultAllColumnSort;
    },
    vxeColumns: function vxeColumns() {
      var columnWidth = this.columnWidth,
          expandConfig = this.expandConfig,
          innerDefaultAllColumnSort = this.innerDefaultAllColumnSort,
          isTree = this.isTree,
          schema = this.schema,
          treeNode = this.treeNode,
          _uiSchema = this.uiSchema,
          uiSchema = _uiSchema === undefined ? {} : _uiSchema,
          $scopedSlots = this.$scopedSlots;

      var ret = Object(_util__WEBPACK_IMPORTED_MODULE_3__[/* convertSchemaToColumns */ "a"])(schema, uiSchema, $scopedSlots, columnWidth, {
        expand: expandConfig,
        defaultAllColumnSort: innerDefaultAllColumnSort
      });
      if (isTree) {
        var treeColumn = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.find(ret, function (col) {
          return col.field === treeNode;
        });
        if (treeColumn) {
          treeColumn.treeNode = true;
        }
      }
      return ret;
    },

    /**
     * 处理公共列(首列选择列和尾列操作按钮列)
     * @returns
     */
    vxeTableColumnArray: function vxeTableColumnArray() {
      var getDefaultControlColumn = this.getDefaultControlColumn,
          multipleSelection = this.multipleSelection,
          selectionType = this.selectionType,
          innerDefaultAllColumnSort = this.innerDefaultAllColumnSort;

      var columns = this.innerTableColumns || [];
      var selectColumn = selectionType;
      if (multipleSelection) {
        selectColumn = 'checkbox';
      }
      var selectionColumn = this.createSelectionColumn(selectColumn);
      if (columns && selectionColumn) {
        // !FIXME 组件创建后，更改selectionType时不会触发重新构建VxeColumn计算属性。
        var index = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.findIndex(columns, function (col) {
          return col.type === 'checkbox' || col.type === 'radio';
        });
        // 更新选择方式(多选/单选)
        if (index !== -1 && columns[index].type !== selectionColumn.type) {
          columns[index].type = selectionColumn.type;
          // 新增选择列
        } else if (index === -1) {
          columns.unshift(selectionColumn);
        }
      }
      var isMultipleLevelHeader = columns.some(function (column) {
        var srParentField = column.srParentField;
        // 存在复合表头的场合

        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(srParentField)) {
          return true;
        }
        return false;
      });
      // 存在多级表头的场合
      if (isMultipleLevelHeader) {
        columns = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.toArrayTree(lodash__WEBPACK_IMPORTED_MODULE_0___default.a.cloneDeep(columns), {
          parentKey: 'srParentField',
          key: 'field'
        });
        columns.forEach(function (col) {
          var parentColumn = col;
          // 复合表头不进行排序
          if (innerDefaultAllColumnSort && !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(col.children)) {
            parentColumn.sortable = false;
          }
        });
      }
      var controlColumn = getDefaultControlColumn();
      if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(controlColumn)) {
        columns = columns.concat([controlColumn]);
      }
      this.initialColumnSettingKeys(columns);
      return columns;
    },
    isMultipleSelect: function isMultipleSelect() {
      if (this.multipleSelection || this.selectionType === 'checkbox') {
        return true;
      }
      var index = this.vxeTableColumnArray.findIndex(function (col) {
        return col.type === 'checkbox';
      });
      var ret = index !== -1;
      return ret;
    },
    innerSortList: function innerSortList() {
      var sortList = this.sortList;

      return sortList;
    },
    innerPaginationTotal: function innerPaginationTotal() {
      var autoPagination = this.autoPagination,
          showPagination = this.showPagination,
          isTree = this.isTree,
          innerDataList = this.innerDataList,
          innerTotal = this.innerTotal,
          innerTreeDataList = this.innerTreeDataList;

      if (showPagination) {
        if (autoPagination) {
          if (isTree) {
            return innerTreeDataList.length;
          }
          return innerDataList.length;
        }
        return innerTotal;
      }
      return innerDataList.length;
    },
    innerMergeCells: function innerMergeCells() {
      var mergeCells = this.mergeCells,
          innerCurrentPage = this.innerCurrentPage,
          innerPageSize = this.innerPageSize,
          innerDataList = this.innerDataList;

      if (mergeCells && lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isFunction(mergeCells)) {
        return mergeCells(innerDataList, innerCurrentPage, innerPageSize);
      }
      return null;
    }
  },
  created: function created() {
    var innerSortConfig = this.innerSortConfig;

    var defaultSort = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.get(innerSortConfig, 'defaultSort');
    if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(defaultSort)) {
      var field = defaultSort.field,
          order = defaultSort.order;

      this.sortList.push({
        property: field,
        order: order
      });
    }
  },

  methods: {
    /**
     * 用于 type=checkbox，切换某一行的选中状态
     * @public
     * @param {object} row
     */
    toggleCheckboxRow: function toggleCheckboxRow(row) {
      this.getTableRef().toggleCheckboxRow(row);
    },

    /**
     * 用于多选表格，清空全部用户选择项（当前页和保留的选择项）
     * @public
     */
    clearSelection: function clearSelection() {
      if (this.isMultipleSelect) {
        this.getTableActionRef().clearCheckboxRow();
        this.getTableActionRef().clearCheckboxReserve();
      } else if (this.selectionType === 'radio') {
        this.getTableActionRef().clearRadioRow();
        this.getTableActionRef().clearRadioReserve();
      }
    },

    /**
     * 排序
     * @param {*} data
     * @param {array} fieldConfs {property, order}
     */
    sortData: function sortData(data, fieldConfs) {
      if (lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(data)) {
        return data;
      }
      var sortMethod = this.sortMethod,
          isTree = this.isTree,
          schema = this.schema;
      // 自定义排序函数的场合

      if (typeof sortMethod === 'function') {
        return sortMethod(data, fieldConfs, schema);
      }
      var confs = [];
      // 转换函数
      var orderFunction = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.orderBy;
      fieldConfs.forEach(function (item) {
        var property = item.property,
            order = item.order;

        var key = property;
        var orderKey = key;
        var schemaProperty = schema.properties[key];
        if (schemaProperty) {
          if (schemaProperty.format === 'price') {
            orderKey = function orderKey(rowItem) {
              var ret = rowItem[key];
              ret = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.toNumber(ret);
              if (lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isNaN(ret)) {
                ret = 0;
              }
              return ret;
            };
          }
        }
        confs.push([orderKey, order]);
      });
      // 暂不处理树形结构数据
      if (!isTree) {
        var ret = orderFunction(data, confs);
        return ret;
      }
      return data;
    },

    /**
     * editable-pro-table
     * 获取当前表格的深拷贝数据
     * 数据源为data
     * 用于过滤掉表格渲染用字段
     * @param {excludeFunction} Function 自定义过滤函数
     */
    getFullData: function getFullData(excludeFunction) {
      var data = this.data,
          treeConfig = this.treeConfig;

      if (lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(data)) {
        return data;
      }
      var config = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, treeConfig, {
        // 移除子节点
        clear: true
      });
      var currentData = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.cloneDeep(data);
      var VXETABLE_ITEM_PREFIX = '_X';
      // 移除表格渲染用字段
      currentData = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.mapTree(currentData, function (item) {
        var ret = {};
        Object.keys(item).forEach(function (key) {
          var isNeedExclude = false;
          // 自定义过滤
          if (typeof excludeFunction === 'function' && excludeFunction(key)) {
            isNeedExclude = true;
            // 默认过滤
          } else if (key.indexOf(VXETABLE_ITEM_PREFIX) === 0) {
            isNeedExclude = true;
          }
          if (!isNeedExclude) {
            ret[key] = item[key];
          }
        });
        return ret;
      }, config);
      return currentData;
    },

    /**
     * VxeTable子组件函数调用代理实例
     * @public
     * @returns
     */
    getTableActionRef: function getTableActionRef() {
      var _this = this;

      var ret = this.getTableRef();
      if (ret) {
        ret.clearSelection = function () {
          _this.clearSelection();
        };
        ret.getFullData = function (val) {
          return _this.getFullData(val);
        };
        ret.setFullCheckboxRow = function (val) {
          _this.setFullCheckboxRow(val);
        };
        ret.getAllCheckboxRecords = function () {
          return _this.getAllCheckboxRecords();
        };
      }
      return ret;
    },

    /**
     * 取得VxeTable实例
     * @public
     * @returns
     */
    getTableRef: function getTableRef() {
      return this.$refs.xTable;
    },
    createSelectionColumn: function createSelectionColumn(selectionType) {
      var checkboxConfig = this.checkboxConfig,
          radioConfig = this.radioConfig;

      var getSelectionColumnWidth = function getSelectionColumnWidth(cbConfig, rConfig, st) {
        var DEFAULT_WIDTH = 40;
        if (st === 'checkbox') {
          return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.get(cbConfig, 'width', DEFAULT_WIDTH);
        }
        return lodash__WEBPACK_IMPORTED_MODULE_0___default.a.get(rConfig, 'width', DEFAULT_WIDTH);
      };
      // 选择列（单选、复选）
      var selectionColumn = null;
      if (selectionType) {
        selectionColumn = {
          type: selectionType,
          title: '',
          width: getSelectionColumnWidth(checkboxConfig, radioConfig, selectionType),
          align: 'center',
          fixed: 'left',
          field: ''
        };
      }
      return selectionColumn;
    },
    getDefaultControlColumn: function getDefaultControlColumn() {
      var h = this.$createElement;
      var controlColumnWidth = this.controlColumnWidth,
          getRowButton = this.getRowButton,
          labelMode = this.labelMode,
          onCustomButtonClick = this.onCustomButtonClick;

      if (typeof getRowButton !== 'function') {
        return null;
      }
      return {
        title: COLUMN_CONTROL_TITLE,
        fixed: 'right',
        align: 'center',
        width: controlColumnWidth,
        slots: {
          default: function _default(scope) {
            var h = this.$createElement;

            var controlColumnDefaultSlot = [];
            var rowButtonList = getRowButton(scope) || [];
            if (labelMode !== true) {
              rowButtonList.unshift(MODIFY_BUTTON);
            }
            if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(rowButtonList)) {
              if (rowButtonList.length <= 2) {
                rowButtonList.forEach(function (_ref2) {
                  var key = _ref2.key,
                      label = _ref2.label;

                  controlColumnDefaultSlot.push(h(
                    'el-button',
                    {
                      attrs: {
                        type: 'text'
                      },
                      on: {
                        'click': onCustomButtonClick(key, scope)
                      }
                    },
                    [label]
                  ));
                });
              } else {
                var btnFirst = rowButtonList[0];
                controlColumnDefaultSlot.push(h(
                  'el-button',
                  {
                    attrs: {
                      type: 'text'
                    },
                    on: {
                      'click': onCustomButtonClick(btnFirst.key, scope)
                    }
                  },
                  [btnFirst.label]
                ));
                var moreElt = h(
                  'el-dropdown',
                  { style: 'margin-left: 15px' },
                  [h(
                    'el-button',
                    {
                      attrs: { type: 'text' }
                    },
                    ['\u66F4\u591A', h('i', { 'class': 'el-icon-arrow-down el-icon--right' })]
                  ), h(
                    'el-dropdown-menu',
                    { slot: 'dropdown' },
                    [rowButtonList.map(function (_ref3, index) {
                      var key = _ref3.key,
                          label = _ref3.label;

                      if (index > 0) {
                        return h('el-dropdown-item', [h(
                          'el-button',
                          {
                            attrs: {
                              type: 'text'
                            },
                            on: {
                              'click': onCustomButtonClick(key, scope)
                            }
                          },
                          [label]
                        )]);
                      }
                      return null;
                    })]
                  )]
                );
                controlColumnDefaultSlot.push(moreElt);
              }
            }
            return controlColumnDefaultSlot;
          }
        }
      };
    },

    /**
     * 选中指定行
     * @public
     * @param {Object} data 选中行的数据
     * @param {*} checked 选中状态，默认为true
     */
    setSelection: function setSelection(data) {
      var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var xTable = this.getTableRef();
      var selection = [];
      if (this.isMultipleSelect) {
        xTable.setCheckboxRow(data, checked);
        selection = this.getTableActionRef().getCheckboxRecords(true);
      } else if (this.selectionType === 'radio') {
        if (!checked) {
          xTable.clearRadioRow(data);
        } else {
          xTable.setRadioRow(data);
          selection = [data];
        }
      }
      this.emitSelectionChange(selection);
    },
    reloadColumn: function reloadColumn() {
      var xTable = this.getTableRef();
      if (xTable) {
        xTable.reloadColumn(this.vxeTableColumnArray);
      }
    },

    /**
     * 自定义操作按钮点击事件
     * @param {*} key
     * @param {*} scope
     * @returns
     */
    onCustomButtonClick: function onCustomButtonClick(key, scope) {
      var _this2 = this;

      return function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (key === MODIFY_BUTTON.key) {
          _this2.controlStatus = setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_1__[/* EDIT_TYPE */ "b"].MODIFY;
          _this2.isShowForm = true;
          _this2.formData = scope.row;
        } else {
          _this2.$emit('row-control-button-click', key, scope);
          _this2.$emit('row-button-click', key, scope);
        }
      };
    },

    /**
     * Radio单选框选中事件处理
     * @event
     * @param {Object} param
     */
    onTableRadioChange: function onTableRadioChange(val) {
      var innerRadioConfig = this.innerRadioConfig;

      if (innerRadioConfig && lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isFunction(innerRadioConfig.checkMethod)) {
        if (val && innerRadioConfig.checkMethod(val)) {
          this.emitSelectionChange([val.row]);
        }
      } else {
        this.emitSelectionChange([val.row]);
      }
    },

    /** CheckBox 选中事件 */
    onTableCheckboxChange: function onTableCheckboxChange(val) {
      // !FIXME vxe-table bug - 不存在checkbox多选列的情况下，仍然触发了checkbox-change事件
      if (this.isMultipleSelect) {
        this.emitSelectionChange(val.records);
      }
    },
    onTableCheckboxAll: function onTableCheckboxAll(_ref4) {
      var records = _ref4.records;

      this.emitSelectionChange(records);
      this.$emit('select-all', records);
    },
    emitSelectionChange: function emitSelectionChange(val) {
      var selectionArray = val;
      if (this.isReserve && this.isMultipleSelect) {
        var reserveArray = this.getTableActionRef().getCheckboxReserveRecords();
        selectionArray = selectionArray.concat(reserveArray);
      }
      this.innerSelection = selectionArray;
      this.$emit('selection-change', selectionArray);
    },
    onCellClick: function onCellClick(val) {
      var _this3 = this;

      this.$emit('cell-click', val);
      var isTriggerBySelectColumn = function isTriggerBySelectColumn(target) {
        var ret = target.triggerCheckbox || target.triggerExpandNode || target.triggerRadio || target.triggerTreeNode;
        return ret;
      };
      // 表格处于可编辑状态下，点击不可编辑单元格后，触发选中事件的场合
      if (this.labelMode === false && !isTriggerBySelectColumn(val) && typeof lodash__WEBPACK_IMPORTED_MODULE_0___default.a.get(val, 'column.slots.edit') !== 'function') {
        if (this.selectionType === 'radio') {
          this.setSelection(val.row, true);
        } else if (this.isMultipleSelect) {
          if (this.virtualTree) {
            // !FIXME 需要确认为何此处必须传入数组
            this.toggleCheckboxRow([val.row]);
          } else {
            this.toggleCheckboxRow(val.row);
          }
          this.$nextTick(function () {
            // 手动触发selectionChange
            if (typeof _this3.getTableActionRef().getCheckboxRecords === 'function') {
              _this3.emitSelectionChange(_this3.getTableActionRef().getCheckboxRecords(true));
            }
          });
        }
      }
    },
    onMenuClick: function onMenuClick(val) {
      this.$emit('menu-click', val);
    },
    onCellMenu: function onCellMenu(val) {
      this.$emit('cell-menu', val);
    },
    onSortChange: function onSortChange(val) {
      var sortList = val.sortList;

      this.sortList = sortList;
      this.$emit('sort-change', val);
    },
    onPageChange: function onPageChange(val) {
      var currentPage = val.currentPage,
          pageSize = val.pageSize;

      this.innerCurrentPage = currentPage;
      this.innerPageSize = pageSize;
      this.$emit('page-change', val);
    },
    refreshTempState: function refreshTempState() {
      var tableActionRef = this.getTableActionRef();
      if (tableActionRef) {
        var innerMergeCells = this.innerMergeCells,
            mergeFooterItems = this.mergeFooterItems;
        // 自动刷新合并状态

        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(innerMergeCells)) {
          tableActionRef.setMergeCells(innerMergeCells);
        }
        // 重新合并表尾合计行
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(mergeFooterItems)) {
          this.$nextTick(function () {
            tableActionRef.setMergeFooterItems(mergeFooterItems);
          });
        }
      }
    },
    onColumnSettingTreeCheckboxChange: function onColumnSettingTreeCheckboxChange(val) {
      var _this4 = this;

      this.isAllColumnShow = val;
      if (!val) {
        this.columnSettingDefaultCheckedKeys.forEach(function (key) {
          _this4.getTableActionRef().hideColumn(key);
        });
        this.columnSettingDefaultCheckedKeys = [];
      } else {
        var keys = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.toTreeArray(this.columnSettingKeys).map(function (item) {
          return item.key;
        });
        this.columnSettingDefaultCheckedKeys = keys;
        this.columnSettingDefaultCheckedKeys.forEach(function (key) {
          _this4.getTableActionRef().showColumn(key);
        });
      }
      // 更新列设置树的checkbox状态
      this.$refs.columnSettingTree.setCheckedKeys(this.columnSettingDefaultCheckedKeys, val);
    },
    onColumnSettingTreeNodeCheck: function onColumnSettingTreeNodeCheck(data, checked, indeterminate) {
      var _this5 = this;

      var nodeData = data;
      var key = nodeData.key;
      // 忽略父节点

      if (indeterminate) {
        return;
      }
      var targetTableColumn = this.getTableActionRef().getColumnByField(key);
      if (targetTableColumn) {
        // vxe-table在分组表头的场合，父表头的显示隐藏需要通过子表头的状态进行控制
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(targetTableColumn.children)) {
          targetTableColumn.children.forEach(function (col) {
            var colItem = col;
            colItem.visible = checked;
          });
        } else {
          targetTableColumn.visible = checked;
        }
      }
      // 更新表格列状态
      this.getTableActionRef().refreshColumn().then(function () {
        // 更新表格的临时状态
        _this5.refreshTempState();
        _this5.refreshColumnSettingTopCheckboxStatus();
      });
    },
    refreshColumnSettingTopCheckboxStatus: function refreshColumnSettingTopCheckboxStatus() {
      var _this6 = this;

      var columnFlatArray = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.toTreeArray(this.columnSettingKeys);
      var settingColumnTotalCount = columnFlatArray.length;
      // const visibleColumnCount = _.filter(columnFlatArray,
      //   (item) => item.isColumnVisible).length;
      var visibleColumnCount = 0;
      this.columnSettingKeys.forEach(function (cs) {
        if (_this6.getTableActionRef()) {
          var column = _this6.getTableActionRef().getColumnByField(cs.key);
          if (column && column.visible) {
            visibleColumnCount += 1;
          }
        }
      });
      // 更新checkbox indeterminate 状态
      this.isParticalColumnShow = visibleColumnCount > 0 && visibleColumnCount < settingColumnTotalCount;
      // 更新checkbox选中状态
      this.isAllColumnShow = visibleColumnCount === settingColumnTotalCount;
    },
    initialColumnSettingKeys: function initialColumnSettingKeys(val) {
      if (lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(val)) {
        this.columnSettingKeys = [];
        return;
      }
      this.cloneVxeTableColumnArray = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.cloneDeep(val);
      this.columnSettingKeys = [];
      var settings = xe_utils__WEBPACK_IMPORTED_MODULE_2___default.a.mapTree(val, function (item) {
        var ret = {
          key: item.field,
          title: item.title,
          isColumnVisible: item.visible
        };
        return ret;
      });
      settings = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.filter(settings, function (item) {
        return !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(item.key) && item.title !== COLUMN_CONTROL_TITLE;
      });
      this.columnSettingKeys = settings;
      var visibleKeys = this.columnSettingKeys.filter(function (item) {
        return item.isColumnVisible;
      });
      this.columnSettingDefaultCheckedKeys = visibleKeys.map(function (item) {
        return item.key;
      });
    },
    getColumnSettingRender: function getColumnSettingRender() {
      var _this7 = this;

      var h = this.$createElement;
      var columnSettingKeys = this.columnSettingKeys,
          onColumnSettingTreeCheckboxChange = this.onColumnSettingTreeCheckboxChange,
          onColumnSettingTreeNodeCheck = this.onColumnSettingTreeNodeCheck,
          columnSettingDefaultCheckedKeys = this.columnSettingDefaultCheckedKeys,
          isAllColumnShow = this.isAllColumnShow,
          isParticalColumnShow = this.isParticalColumnShow,
          showColumnSetting = this.showColumnSetting;

      if (showColumnSetting === false) {
        return null;
      }
      var renderContent = function renderContent(h, _ref5) {
        var node = _ref5.node;

        var ret = h(
          'span',
          { 'class': 'custom-tree-node' },
          [h('span', [node.data.title])]
        );
        return ret;
      };
      var onReset = function onReset() {
        _this7.getTableActionRef().resetColumn().then(function () {
          // 更新列设置树的checkbox状态
          _this7.initialColumnSettingKeys(_this7.cloneVxeTableColumnArray);
          // 更新列设置树的checkbox状态
          _this7.$refs.columnSettingTree.setCheckedKeys(_this7.columnSettingDefaultCheckedKeys, true);
        });
      };
      if (columnSettingKeys.length > 0) {
        this.refreshColumnSettingTopCheckboxStatus();
        return h(
          'el-popover',
          {
            attrs: {
              placement: 'bottom',

              width: '240',
              trigger: 'hover',
              'popper-class': 'pro-table__column-setting-tree'
            },
            'class': 'column-setting' },
          [h(
            'div',
            { 'class': 'column-setting__toolbar' },
            [h(
              'el-checkbox',
              {
                attrs: {
                  indeterminate: isParticalColumnShow,
                  value: isAllColumnShow
                },
                on: {
                  'change': onColumnSettingTreeCheckboxChange
                }
              },
              ['\u6240\u6709\u5217']
            ), h(
              'el-button',
              {
                attrs: {
                  type: 'text'
                },
                'class': 'column-setting__reset-button',
                on: {
                  'click': onReset
                }
              },
              ['\u91CD\u7F6E']
            )]
          ), h('el-tree', {
            attrs: {
              data: columnSettingKeys,
              'node-key': 'key',

              'icon-class': 'el-icon-rank',
              props: { label: 'title' },
              'default-expand-all': true,
              'expand-on-click-node': false,
              'default-checked-keys': columnSettingDefaultCheckedKeys,
              'show-checkbox': true,
              'check-on-click-node': true,

              'render-content': renderContent
            },
            ref: 'columnSettingTree', on: {
              'check-change': onColumnSettingTreeNodeCheck
            }
          }), h(
            'el-tooltip',
            {
              attrs: { content: '\u5217\u8BBE\u7F6E', placement: 'top' },
              slot: 'reference' },
            [h(
              'el-button',
              {
                attrs: { icon: 'el-icon-setting', type: 'text' }
              },
              ['\u5217\u8BBE\u7F6E']
            )]
          )]
        );
      }
      return null;
    },
    exportData: function exportData(option) {
      var getTableActionRef = this.getTableActionRef;

      var columns = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.filter(getTableActionRef().getColumns(), function (item) {
        return !lodash__WEBPACK_IMPORTED_MODULE_0___default.a.isEmpty(item.property) && item.title !== COLUMN_CONTROL_TITLE && item.visible;
      });
      columns = columns.map(function (item) {
        var ret = {
          field: item.property
        };
        return ret;
      });
      var defaultConfig = {
        sheetName: '数据',
        type: 'xlsx',
        mode: 'all',
        columns: columns,
        beforeExportMethod: function beforeExportMethod(opt) {
          var options = opt.options;

          var data = getTableActionRef().getFullData();
          if (data && data.length > MAX_EXPORT_DATA_LENGTH) {
            options.isSlice = true;
            data = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.slice(data, 0, MAX_EXPORT_DATA_LENGTH);
          }
          if (options.mode === 'all') {
            options.data = data;
          }
          return opt;
        }
      };
      getTableActionRef().exportData(lodash__WEBPACK_IMPORTED_MODULE_0___default.a.assign({}, defaultConfig, option));
    },

    /**
     * 设置所有数据（包含分页场景下的其他页数据）的选择状态
     * @param val
     */
    setFullCheckboxRow: function setFullCheckboxRow(val) {
      var data = this.data,
          getTableActionRef = this.getTableActionRef,
          isMultipleSelect = this.isMultipleSelect,
          tableListTransform = this.tableListTransform;

      if (!isMultipleSelect) {
        return;
      }
      var tableData = data;
      if (typeof tableListTransform === 'function') {
        tableData = tableListTransform(data);
      }
      if (getTableActionRef()) {
        getTableActionRef().setCheckboxRow(tableData, val);
        this.emitSelectionChange(tableData);
      }
    },
    getAllCheckboxRecords: function getAllCheckboxRecords() {
      var getTableActionRef = this.getTableActionRef,
          isMultipleSelect = this.isMultipleSelect;

      var tableActionRef = getTableActionRef();
      if (isMultipleSelect && tableActionRef) {
        var currentPageCheckboxRecords = tableActionRef.getCheckboxRecords();
        var reserveCheckboxRecords = tableActionRef.getCheckboxReserveRecords();
        return currentPageCheckboxRecords.concat(reserveCheckboxRecords);
      }
      return null;
    },
    isCellButtonClick: function isCellButtonClick(evt) {
      if (evt && evt.path && Array.isArray(evt.path) && evt.path.length > 3) {
        var _evt$path = evt.path,
            c0 = _evt$path[0],
            c1 = _evt$path[1],
            c2 = _evt$path[2];

        if (c0 && c1 && c2) {
          var c0ClassList = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.toArray(c0.classList);
          var c1ClassList = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.toArray(c1.classList);
          var c2ClassList = lodash__WEBPACK_IMPORTED_MODULE_0___default.a.toArray(c2.classList);
          if (c0.tagName === 'SPAN' && c1ClassList.includes('el-button') && c2ClassList.includes('vxe-cell') && c2ClassList.includes('c--tooltip')) {
            return true;
          }
          if (c0ClassList.includes('el-button') && c1ClassList.includes('vxe-cell') && c1ClassList.includes('c--tooltip')) {
            return true;
          }
          return false;
        }
      }
      return false;
    },
    onGridNativeClick: function onGridNativeClick(evt) {
      if (this.isCellButtonClick(evt)) {
        this.$emit('cell-link-click');
      }
    }
  }
});

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JSON_FORM_UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TYPE; });
var JSON_FORM_UI = {
  UI_WIDGET: 'ui:widget',
  UI_OPTIONS: 'ui:options',
  UI_DISABLED: 'ui:disabled',
  UI_HIDDEN: 'ui:hidden',
  UI_FORMAT: 'ui:format',
  UI_ON: 'ui:on',
  UI_NATIVE_ON: 'ui:nativeOn',
  UI_PARENT_COLUMN_ID: 'ui:parentColumnId',
  UI_RULES: 'ui:rules',
  UI_PLACEHOLDER: 'ui:placeholder',
  UI_COLSPAN: 'ui:colspan',
  UI_RULE: 'ui:rules',
  UI_RENDER: 'ui:render'
};

var COLUMN_TYPE = {
  INDEX: 'index'
};

var EDIT_TYPE = {
  ADD: 'add',
  DELETE: 'delete',
  MODIFY: 'modify'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ })

/******/ });